import { Button, DatePicker, Input, Modal, Radio, message } from "antd";
import { useState } from "react";
import { ReactComponent as CopySvg } from "./styles/img/CopySimple.svg";
import dayjs from "dayjs";
import { DeleteOutlined } from "@ant-design/icons";
import { useEffect } from "react";
import config from "../../../config";
import { ReactComponent as OkSvg } from "./styles/img/ok.svg";
import { getReferralData } from "../../../Utils/ReferralUtils";
import { submitCaptcha } from "../../../Utils/captcha";
import styles from "./styles/Referral.module.css";
import { useContext } from "react";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import { ReactComponent as NotokSvg } from "./styles/img/not_ok.svg";
import { UserData } from "../../../Context/DataContext";
const base_url = config.base_url;
function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}
function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

function CampaignSection({
  canBeDeleted,
  setCampaginNumber,
  data,
  setCodeDeleted,
  setReferralData,
  setSavedCampagins,
}) {
  const userData = UserData();

  const websiteCurrentLang = useContext(LanguageContext).language;
  const [expirationDate, setExpirationDate] = useState(
    data.expiration_date
      ? dayjs(new Date(data.expiration_date))
      : dayjs(new Date().now)
  );
  const [hasExpirationDate, setHasExpirationDate] = useState(
    data.expiration_date ? true : false
  );

  const [referralCode, setReferralCode] = useState(data.code);
  useEffect(() => {
    setReferralCode(data.code);
  }, [data]);
  const [messageApi, contextHolder] = message.useMessage();
  const { height, width } = useWindowDimensions();
  const [buttonLoading, setButtonLoading] = useState(false);

  const [codeAvailable, setCodeAvailable] = useState(false);
  const [codeAvailableTouched, setCodeAvailableTouched] = useState(false);
  const [timer, setTimer] = useState(undefined);
  const [referralEmail, setReferralEmail] = useState("");
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [invalidEmailFormat, setInvalidEmailFormat] = useState(false);
  const [dublicatedEmail, setDublicatedEmail] = useState(false);
  const [emailInputTouched, setEmailInputTouched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [content, setContent] = useState(
    websiteCurrentLang.content.User.MyAccount.ReferralContent
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.MyAccount.ReferralContent);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);

  const success = (text) => {
    messageApi.open({
      type: "success",
      content: text,
    });
  };
  const getReferral = async () => {
    await fetch(base_url + "user/referral/data", {
      method: "POST",
      mode: "cors",
      body: ``,
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        setReferralData(res);
        userData.setReferralData(res);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const addCampaign = async () => {
    if (!data.code) return;
    if (!codeAvailable) return;
    setCodeAvailableTouched(true);
    setButtonLoading(true);
    await fetch(base_url + "user/partner/campaign/add", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body:
        hasExpirationDate === false
          ? `coupon=${data.code}`
          : `coupon=${data.code}&expiration_date=${expirationDate.valueOf()}`,
    })
      .then((res) => {
        if (res.status === 409) {
          const error = {};
          error.code = res.status;
          error.statusText = res.statusText;
          throw error;
        }
        return res.json();
      })
      .then((data) => {
        setSavedCampagins(data);
        setCampaginNumber((prev) => {
          const x = prev.filter(
            (obj1) => !data.some((obj2) => obj2.code === obj1.code)
          );

          return [...data, ...x];
        });
        success(dublicatedcontent.dublicatedText131);
        setButtonLoading(false);
      })
      .catch((err) => {
        if (err.code === 409) {
          setCodeAvailable(false);
        }
        setButtonLoading(false);
      });
  };

  const editCampaign = async () => {
    setButtonLoading(true);

    let requestBody = ``;
    if (data.code === referralCode && hasExpirationDate === false) {
      requestBody = `coupon=${data.code}`;
    } else if (data.code !== referralCode && hasExpirationDate === false) {
      requestBody = `coupon=${data.code}&new_coupon=${referralCode}`;
    } else if (data.code === referralCode && hasExpirationDate === true) {
      requestBody = `coupon=${
        data.code
      }&expiration_date=${expirationDate.valueOf()}`;
    } else if (data.code !== referralCode && hasExpirationDate === true) {
      requestBody = `coupon=${
        data.code
      }&expiration_date=${expirationDate.valueOf()}&new_coupon=${referralCode}`;
    }

    await fetch(base_url + "user/partner/campaign/edit", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: requestBody,
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          const error = {};
          error.code = 409;
          error.statusText = data.error;
          throw error;
        }
        setCodeAvailable(true);
        setButtonLoading(false);
        success(dublicatedcontent.dublicatedText132);
        setSavedCampagins(data);
        setCampaginNumber((prev) => {
          const x = prev.filter(
            (obj1) => !data.some((obj2) => obj2.code === obj1.code)
          );
          const y = x.filter((camp) => {
            return camp.newCampaign === true;
          });

          return [...data, ...y];
        });
        setButtonLoading(false);
      })
      .catch((err) => {
        if (err.code === 409) {
        }
        setButtonLoading(false);
      });
  };
  const deleteCampaign = async () => {
    if (data.newCampaign) {
      setCampaginNumber((prev) => {
        const x = prev.filter((campaign) => campaign.id !== data.id);
        return x;
      });
      setCodeAvailableTouched(false);
      return;
    }

    if (!data?.code) {
      setCampaginNumber((prevCampaigns) =>
        prevCampaigns?.filter((e) => e?.url !== data?.url)
      );
      return;
    }
    setButtonLoading(true);
    await fetch(base_url + "user/partner/campaign/delete", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `coupon=${data.code}`,
    })
      .then((res) => {
        return res.json();
      })
      .then((newData) => {
        setCodeDeleted(newData);
        setButtonLoading(false);
        setSavedCampagins(newData);

        setCodeAvailableTouched(false);
        if (newData.length === 0) {
          setCampaginNumber([
            {
              newCampaign: true,
              url: `${window?.location?.protocol}//${window?.location?.host}/register/?referral=YOUR CODE`,
            },
          ]);

          return;
        }

        setCampaginNumber((prev) => {
          const x = prev.filter((item) => item.code !== data.code);
          return x;
        });
      })
      .catch((err) => {
        console.log(err);
        setButtonLoading(false);
      });
  };
  const verifyCode = async () => {
    if (referralCode?.trim()?.length === 0 || !referralCode) return;
    console.log(referralCode);
    await fetch(base_url + "user/partner/code/availability", {
      method: "POST",
      mode: "cors",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
      body: `coupon=${referralCode}`,
    })
      .then((res) => res.json())
      .then((res) => {
        setCodeAvailable(res.available);
        setCodeAvailableTouched(true);
      });
  };
  useEffect(() => {
    // This effect will run when the component mounts or when timeoutId changes
    return () => {
      // Cleanup function to clear the timeout when the component unmounts or timeoutId changes
      if (timer) {
        clearTimeout(timer);
      }
    };
  }, [timer]);

  const setNewTimeout = () => {
    // Clear the existing timeout if it exists

    if (timer) {
      clearTimeout(timer);
    }

    setTimer(
      setTimeout(() => {
        setEmailInputTouched(false);
        // Your timeout callback function
      }, 3000)
    ); // 5000 milliseconds = 5 seconds
  };
  const sendEmail = async (e) => {
    e.preventDefault();
    clearTimeout(timer);

    if (!data?.code) return;
    setEmailInputTouched(true);
    setLoading(true);
    setInvalidEmailFormat(false);
    setEmailInvalid(false);
    setDublicatedEmail(false);
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (!emailRegex.test(referralEmail)) {
      setInvalidEmailFormat(true);

      setLoading(false);
      return;
    }

    const token = await submitCaptcha();

    await getReferralData()
      .then((res) => {
        return res.json();
      })
      .then((referalData) => {
        let code = referalData.filter((code) => code.code === data.code);

        if (code.length === 0) {
          code = referalData;
        }

        fetch(base_url + "user/referral/invite", {
          method: "POST",
          mode: "cors",
          body: `email=${referralEmail}&token=${token}&code=${code[0].code}`,
          headers: {
            Accept: "application/json, text/plain, */*",
            "Content-type": "application/x-www-form-urlencoded",
            credentials: "include",
          },
          credentials: "include",
        })
          .then((res) => {
            return res.json();
          })
          .then((res) => {
            if (res.ErrorText === "Duplicated") {
              setDublicatedEmail(true);
              setLoading(false);
              return;
            }
            if (res.ErrorText === "Duplicated") {
              setEmailInvalid(true);
              setLoading(false);
              return;
            }

            setEmailInvalid(false);
            setLoading(false);
            getReferral();
            if (width >= 800) {
              setNewTimeout();
            } else success(dublicatedcontent.dublicatedText133);
          })
          .catch((err) => {
            setLoading(false);
            console.log(err);
          });
      })
      .catch((e) => {
        console.log(e);
        setLoading(false);
      });

    // do something with back end
  };
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        backgroundColor: "#f9f9f9",
        marginBottom: "25px",
        borderRadius: "20px",
      }}
    >
      {contextHolder}
      <div className="campaignSection">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <p
            className="campaignSection_title"
            style={{
              width: "max-content",
            }}
          >
            {dublicatedcontent.dublicatedText134}
            <span
              style={
                data.newCampaign
                  ? {
                      marginLeft: "10px",
                      fontWeight: 400,
                      fontSize: "12px",
                      color: "red",
                    }
                  : {
                      marginLeft: "10px",
                      color: "#419F23",
                      fontWeight: 400,
                      fontSize: "12px",
                    }
              }
            >
              {!data.newCampaign &&
                (data.valid
                  ? dublicatedcontent.dublicatedText135
                  : dublicatedcontent.dublicatedText136)}
              {data.newCampaign && dublicatedcontent.dublicatedText249}
            </span>
          </p>
          {/* Avoid deleting campaign if we dont have code */}
          {/* {canBeDeleted && data?.code && (
            <div
              className="deleteCampaign"
              onClick={(e) => {
                deleteCampaign();
              }}
            >
              <DeleteOutlined />
              <p>{dublicatedcontent.dublicatedText137}</p>
            </div>
          )} */}
          {canBeDeleted && (
            <div
              className="deleteCampaign"
              onClick={(e) => {
                deleteCampaign();
              }}
            >
              <DeleteOutlined />
              <p>{dublicatedcontent.dublicatedText137}</p>
            </div>
          )}
        </div>
        {/* TODO: un-comment this section when email translation is ready */}
        <div className="campaignSection_inviteViaEmail">
          <p className="campaignSection_inviteViaEmail_title">
            {dublicatedcontent.dublicatedText138}
          </p>
          <p className="campaignSection_inviteViaEmail_text">
            {dublicatedcontent.dublicatedText140}
          </p>

          <form id="sendInvite" onSubmit={(e) => sendEmail(e)} className="">
            <div
              onSubmit={(e) => sendEmail(e)}
              className="inviteViaEmailWrapper"
            >
              <Input
                disabled={data?.code ? false : true}
                type="email"
                value={referralEmail}
                onChange={(e) => {
                  setReferralEmail(e.target.value.trim());
                }}
                placeholder={dublicatedcontent?.dublicatedText74}
                className="emailInput"
              />
              <Button
                disabled={data?.code ? false : true}
                htmlType="submit"
                loading={loading}
                className="inviteButton"
              >
                {dublicatedcontent.dublicatedText120}
              </Button>
              {emailInputTouched &&
                !emailInvalid &&
                !loading &&
                !invalidEmailFormat &&
                !dublicatedEmail &&
                width >= 800 && (
                  <div
                    className={styles.section3SuccessMessageContainer}
                    style={{
                      height: "40px ",
                    }}
                  >
                    <OkSvg />
                    <p>{content.referralSection3EmailSuccess}</p>
                  </div>
                )}
            </div>
            {emailInvalid && emailInputTouched && (
              <div className={styles.section3ErrorMessageContainer}>
                <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
                <p className={styles.section3ErrorMessageContainerMessage}>
                  {content.referralSection3EmailFailed}
                </p>
              </div>
            )}
            {invalidEmailFormat && emailInputTouched && (
              <div className={styles.section3ErrorMessageContainer}>
                <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
                <p className={styles.section3ErrorMessageContainerMessage}>
                  {content.referralSection3EmailFailedFormat}
                </p>
              </div>
            )}{" "}
            {dublicatedEmail && emailInputTouched && (
              <div className={styles.section3ErrorMessageContainer}>
                <NotokSvg className={styles.section3ErrorMessageContainerSvg} />
                <p className={styles.section3ErrorMessageContainerMessage}>
                  {content.referralSection3DublicatedEmail}
                </p>
              </div>
            )}
          </form>
        </div>
        <div className="campaignSection_referralLink">
          <p
            className="campaignSection_referralLink_title"
            style={{
              //  TODO: un-comment this section when email translation is ready
              border: "none ",
            }}
          >
            {dublicatedcontent.dublicatedText141}
          </p>
          <div className="campaignSection_referralLink_link">
            <p> {data.url}</p>
            <CopySvg
              onClick={(e) => {
                navigator.clipboard.writeText(`${data.url}`);
                success(dublicatedcontent.dublicatedText142);
              }}
              style={{
                cursor: "pointer",
              }}
            />
          </div>
        </div>
        {width < 400 ? (
          <div className="campaignSection_referralCode">
            <p className="campaignSection_referralCode_text">
              {dublicatedcontent.dublicatedText143}
            </p>
            <p
              style={{
                fontSize: "14px",
                fontWeight: "400",
                margin: "0",
              }}
            >
              {dublicatedcontent.dublicatedText144}
            </p>
            <div className="campaignSection_referralCode_inputWrapper">
              <div className="campaignSection_referralCode_inputWrapperRow1">
                <Input
                  // disabled={data.newCampaign ? false : true}

                  value={data.newCampaign ? data.code : referralCode}
                  onChange={(e) => {
                    if (data.newCampaign) {
                      setCampaginNumber((prev) => {
                        const x = prev.findIndex(
                          (campaign) => campaign?.id === data.id
                        );
                        if (x !== -1) {
                          prev[x].code = e.target.value; //
                        }
                        return prev;
                      });
                    }
                    setCodeAvailableTouched(false);
                    setReferralCode(e.target.value);
                  }}
                  placeholder={dublicatedcontent.dublicatedText145}
                  className="referralCodeInput"
                  onBlur={(e) => {}}
                />
                <CopySvg
                  onClick={(e) => {
                    navigator.clipboard.writeText(referralCode);
                    success(dublicatedcontent.dublicatedText142);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </div>
              {codeAvailable && codeAvailableTouched && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <OkSvg />
                  <p
                    style={{
                      margin: "0",
                    }}
                  >
                    {dublicatedcontent.dublicatedText146}
                  </p>
                </div>
              )}
              {!codeAvailable && codeAvailableTouched && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "#FF0000",
                    }}
                  >
                    {dublicatedcontent.dublicatedText147}
                  </p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="campaignSection_referralCode">
            <p className="campaignSection_referralCode_text">
              {dublicatedcontent.dublicatedText143}
              <span
                style={{
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                {dublicatedcontent.dublicatedText144}
              </span>
            </p>
            <div className="campaignSection_referralCode_inputWrapper">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <Input
                  // disabled={data.newCampaign ? false : true}
                  onBlur={(e) => {
                    if (e.target.value !== data.code) {
                      verifyCode(e.target.value);
                    }
                    if (data.newCampaign) {
                      verifyCode(e.target.value);
                    }
                  }}
                  value={data.newCampaign ? data.code : referralCode}
                  onChange={(e) => {
                    if (data.newCampaign) {
                      setCampaginNumber((prev) => {
                        const x = prev.findIndex(
                          (campaign) => campaign?.id === data.id
                        );
                        if (x !== -1) {
                          prev[x].code = e.target.value; //
                        }
                        return prev;
                      });
                    }
                    setCodeAvailableTouched(false);
                    setReferralCode(e.target.value);
                  }}
                  placeholder={dublicatedcontent.dublicatedText145}
                  className="referralCodeInput"
                />
                <CopySvg
                  onClick={(e) => {
                    navigator.clipboard.writeText(referralCode);
                    success(dublicatedcontent.dublicatedText142);
                  }}
                  style={{
                    cursor: "pointer",
                  }}
                />
              </div>
              {codeAvailable && codeAvailableTouched && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <OkSvg />
                  <p
                    style={{
                      margin: "0",
                    }}
                  >
                    {dublicatedcontent.dublicatedText146}
                  </p>
                </div>
              )}
              {!codeAvailable && codeAvailableTouched && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <p
                    style={{
                      margin: "0",
                      color: "#FF0000",
                    }}
                  >
                    {dublicatedcontent.dublicatedText147}
                  </p>
                </div>
              )}
            </div>
          </div>
        )}

        <div className="campaignSection_expirationDate">
          <p className="campaignSection_expirationDate_title">
            {dublicatedcontent.dublicatedText148}
          </p>

          <Radio.Group
            defaultValue={hasExpirationDate ? 2 : 1}
            onChange={(e) => {
              if (e.target.value === 1) {
                setHasExpirationDate(false);
                setExpirationDate(null);
              } else if (e.target.value === 2) {
                setHasExpirationDate(true);
                setExpirationDate(dayjs(new Date().now));
              }
            }}
            className="campaignSection_expirationDate_radio"
          >
            <div
              className="campaignSection_expirationDate_radio_wrapper"
              direction="vertical"
            >
              <Radio value={1}>{dublicatedcontent.dublicatedText149}</Radio>
              <div className="campaignSection_expirationDate_radio_hasExpiration">
                <Radio value={2}>{dublicatedcontent.dublicatedText150}</Radio>
                {hasExpirationDate === true && (
                  <DatePicker
                    className="datePicker"
                    value={expirationDate}
                    onChange={(e) => {
                      setExpirationDate(e);
                    }}
                    defaultValue={dayjs(new Date().now)}
                    allowClear={false}
                    format={"YYYY-MM-DD"}
                    disabledDate={(current) => {
                      let customDate = dayjs().format("YYYY-MM-DD");
                      return (
                        current && current < dayjs(customDate, "YYYY-MM-DD")
                      );
                    }}
                  />
                )}
                <Button
                  disabled={referralCode?.trim().length > 0 ? false : true}
                  // style={buttonLoading ? { width: "80px" } : {}}
                  className="saveButton"
                  onClick={(e) => {
                    if (data.newCampaign) {
                      addCampaign();
                    } else editCampaign();
                  }}
                  loading={buttonLoading}
                >
                  {dublicatedcontent.dublicatedText151}
                </Button>
              </div>
            </div>
          </Radio.Group>
        </div>
      </div>
    </div>
  );
}

export default CampaignSection;
